












































































import { Vue, Component, Prop } from "vue-property-decorator";
import ModalRep from "@/components/Modal/ModalRep.vue";
import { User } from "@/models/user_schema";
import { Address } from "../../../models/address";
import { Brand } from "../../../models/brands_schema";
import { SalesRegionsStringType } from "@/models/map/region_type";
import { EventBus } from "@/events/index";
import RepService from "@/services/rep_service";
import { StoreModule } from "@/store/types";
import { RepActions } from "@/store/modules/rep/types";
import { namespace } from "vuex-class";
import { UserGetters } from "@/store/modules/user/types";
import { Roles } from "@/models/roles";
import { CustomerGetters } from "@/store/modules/customer/types";
import { CustomerType } from "@/models/customer";

@Component({
  components: {
    ModalRep,
  },
})
export default class Rep extends Vue {
  @Prop() address!: Address[];
  @Prop() rep_info!: User["rep_info"];
  @Prop() email?: User["email"];
  @Prop() first_name?: User["first_name"];
  @Prop() _id!: User["_id"];
  @Prop() last_name?: User["last_name"];
  @Prop() phone?: User["phone"];
  @Prop() activityUpdate?: string | false | undefined;
  protected repService = new RepService();
  protected Roles = Roles;
  protected singleView = false;
  @(namespace(StoreModule.Rep).Action(RepActions.DeleteRep)) delete;
  @(namespace(StoreModule.User).Getter(UserGetters.GetRole)) role;
  @(namespace(StoreModule.Customer).Getter(CustomerGetters.GetAllCustomers))
  customers;
  @(namespace(StoreModule.Rep).Action(RepActions.SetSelectedRep))
  addActiveRep;

  created() {
    if (this.$route.params.id) {
      this.singleView = true;
    }
  }

  get repAddress(): Address {
    return this.address[0];
  }

  get sales_region(): SalesRegionsStringType {
    if (this.rep_info!.sales_region.includes('-')) {
          return this.rep_info!.sales_region.split('-').map((s) => s.charAt(0).toUpperCase() + s.substring(1)).join('-');
    } else {
          return this.rep_info!.sales_region.split(' ').map((s) => s.charAt(0).toUpperCase() + s.substring(1)).join(' ');
    }
  }



  get salesRegionFormatted(): string {
    let value;
    if (this.sales_region) {
      value = this.sales_region.replace(/ /g, "_");
    }
    return value;
  }

  protected async deleteRep(): Promise<void> {
    await this.delete(this._id);
    if (this.singleView) {
      this.$router.push({ path: "/" });
    }
    this.addActiveRep({});
  }

  protected handleSelection(): void {
    EventBus.$emit(
      "handleRepSelection",
      this.sales_region,
      this.first_name,
      this.last_name
    );
    this.filterFooterData(this.sales_region);
    if (!this.$route.params.id) {
      this.$router.push({
        path: "/reps/" + this._id,
        query: { region: this.sales_region },
      });
    }
  }

  protected filterFooterData(region: SalesRegionsStringType | undefined): void {
    const regionArray = this.customers.filter((customer) => {
      return customer.sales_region === region && (CustomerType.Customer || customer.customer_type === CustomerType.Designer);
    });
    EventBus.$emit("sendFooterData", regionArray);
  }

  protected triggerRep(): void {
    this.$modal.show(
      ModalRep,
      { isEdit: true, data: this.$props },
      { adaptive: true, width: 860, height: "auto", scrollable: true }
    );
  }
}
